// src/pages/Login.tsx
import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Login.css';

interface LoginProps {
  onLoginSuccess: () => void;
}

// Use absolute URL for API calls
const API_BASE_URL = window.location.hostname === 'flabs2fabs.omchat.ovh' 
  ? 'https://flabs2fabs.omchat.ovh'
  : 'http://localhost:8008';

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
        username,
        password,
      });

      const { access_token, refresh_token } = response.data;

      // Store tokens
      localStorage.setItem('flab2fabs_token', access_token);
      localStorage.setItem('flab2fabs_refresh_token', refresh_token);
      localStorage.setItem(
        'flab2fabs_user',
        JSON.stringify({ name: username })
      );

      console.log('Login successful → redirecting');

      // 🔑 Notify App.tsx
      onLoginSuccess();
    } catch (err: any) {
      console.error('Login failed:', err);
      setError(err.response?.data?.detail || 'Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <span className="logo-icon">🔥</span>
          <h1>Flab2Fabs</h1>
          <p>Your emotional training partner for fitness success</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
